<div class="modal-wrapper">
  <div class="modal-header">
    @if (data.type == 6) {
      <div class="">
        <img src="assets/New 211 logo.jpg" alt="" class="modal-header-image">
      </div>
    }
    <div class="modal-title">
      <h1 mat-dialog-title>{{data.commonName}}</h1>
    </div>

  </div>

  <div class="modal-content" mat-dialog-content>
    <div class="items-center">
      @if (addressString) {
      <div class="min-w-0">
        <p class="text-sm">
          {{'Address:'|translate}} <span class="text-gray-500">
            <a [href]="'http://maps.google.com/maps?q='+addressString">{{ addressString }}</a>
          </span>
        </p>
      </div>
      }
      @if(data.phone) {
      <div class="min-w-0">
        <p class="text-sm">
          {{'Phone:'| translate}}<span class="text-gray-500"> <a [href]="'tel:' + data.phone">{{data.phone}}</a></span>
        </p>
      </div>
      }
    </div>
  </div>
  @if (data.website) {
  <div mat-dialog-actions class="text-center justify-center modal-actions">
    <div style="margin-left: auto; margin-right: auto;">
      <a *ngIf="data.website" [href]="data.website" class="items-center shadow-sm p-4 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50">
        <span class="px-2">{{'Visit website'|translate}}</span>
      </a>
    </div>
  </div>
  }

</div>

